import { Preview } from "../../../types/schedule/preview";
import { PreviewDto } from "../../../types/schedule/preview-dto";
import { convertDeliverySegmentDtoToDeliverySegment } from "./delivery-segment-converter";
import { convertPreviewDeliveryGroupDtoToDeliveryGroup } from "./preview-delivery-group-converter";

export const convertPreviewDtoToPreview = (
  previewDto: PreviewDto,
  currentDeliveryGroupIndex?: number
): Preview => {
  return {
    deliverySegments: previewDto.deliverySegments.map((deliverySegmentDto) =>
      convertDeliverySegmentDtoToDeliverySegment(deliverySegmentDto)
    ),
    deliveryGroups: previewDto.deliveryGroups.map((deliveryGroupDto, index) =>
      convertPreviewDeliveryGroupDtoToDeliveryGroup(
        deliveryGroupDto,
        index,
        currentDeliveryGroupIndex
      )
    ),
  };
};
